/**
 * All common service functions will go here
 * Remove/add functions on the basis of requirement
 * Added functionality for pdf file open in new browser tab, remove if not needed
 * Disable/Enable body scroll on loader show/hide. Remove if not required
 */
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpService } from '../../services/http.service';

import { DynamicItem } from 'src/app/models/dynamicItem';
import { MessagesComponent } from '../../components/popups/messages/messages.component';

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    
    constructor(
        private httpService: HttpService
    ) {}

    vuaExtension = "@onemoney";
    phoneExtension = "+91";
    consentPinLength = 6;
    fipList;
    fiuList;
    messagePopupData = new Subject<any>(); // To send message to global message popup
    globalMessagePopupVisibility = new Subject<boolean>(); // To change visibility of the global message popup
        

    /**
     * disable body scrolling on popup open
     */
    disableBodyScroll() {
        document.body.classList.add('body-has-loader');
    }

    /**
     * enable body scrolling on popup close
     */
    enableBodyScroll() {
        document.body.classList.remove('body-has-loader');
    }

    /**
     * this function is used for pdf to dowload/open-in-new-tab
     * @param response - pdf bob data
     */
    downloadFile(response, fileName) {
        if (response.status != 'failure') {
            const blob = new Blob([response._body], { type: 'application/pdf' });
            // saveAs(blob, fileName);

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob);
                return;
            }

            // For other browsers: 
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(blob);
            // var link = document.createElement('a');
            // link.setAttribute('target', '_blank');
            // link.href = data;
            var is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/); 
            
            if (navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) { //Safari & Opera iOS
                // var url = window.URL.createObjectURL(blob);
                window.location.href = data; // if it doesn't work, change 'data' to 'url' and uncomment above line
            } else if(is_safari) {
                this.openTab(data);
            } else {
                window.open(data);
            }
            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
            }, 100)
        }
    }

    /**
     * this function is purely for Safari browser to open the file url in new tab
     * @param url {string} - url of the file
     */
    openTab(url) {
        // Create link in memory
        var a = window.document.createElement("a");
        a.target = '_blank';
        a.href = url;
     
        // Dispatch fake click
        var e = window.document.createEvent("MouseEvents");
        e.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        a.dispatchEvent(e);
    };


    /*this function is used to get the list of identifier*/
    getUserIdentifiers() {
        let options = {
            type: 'get',
            url: 'userIdentifier',
            includeUserSession: true,
        }
        return this.httpService.makeHttpRequest(options);
    }

    postIdentifiersInfo(identifierInfo) {
        identifierInfo.verificationStatus = "verified"; //For now sending verified manually

        let options = {
            type: 'post',
            url: 'userIdentifier',
            includeUserSession: true,
            data: identifierInfo
        }
        return this.httpService.makeHttpRequest(options);
    }

    deleteIdentifier(identifierId) {
        let options = {
            type: 'delete',
            url: 'userIdentifier',
            includeUserSession: true,
            pathVariables: [identifierId],
        }
        return this.httpService.makeHttpRequest(options);
    }

    /**
     * this function is used to return dummy observable for given data
     * @param data {any} - data to make as dummy observable
     */
    returnDummyObservable(data) {
        return Observable.of({status: "success", data: data});
    }



    /**
     * Get the FIPList from server
     */
    getFIPList() {
        if (this.fipList == undefined || this.fipList == null) {
            let options = {
                url:'fipList',
                type:'get'
            }
            return this.httpService.makeHttpRequest(options).map(res => {
                this.fipList = res;
                return res;
            });
        } else {
            return Observable.of(this.fipList);
        }
    }

    /**
     * Get the FIUList from server
     */
    getFIUList() {
        if (this.fiuList == undefined || this.fiuList == null) {
            let options = {
                url:'fiuList',
                type:'get'
            }
            return this.httpService.makeHttpRequest(options).map(res => {
                this.fiuList = res;
                return res;
            });
        } else {
            return Observable.of(this.fiuList);
        }
    }
    /**
     * To return global message data obsrevable
     * @returns global message data obsrevable
     */
    getGlobalMessageObservable(): Subject<any> {
        return this.messagePopupData;
    }

    /**
     * To produce observable data to be subscribed
     * @param messageData {any} message popup data
     */
    showGlobalMessage(popuptext: any): void {
        popuptext.confirmCallBack = this.toggleGlobalMessagePopupVisibility.bind(this);;
        let popupData = new DynamicItem(MessagesComponent, popuptext);

        this.messagePopupData.next(popupData);
        this.globalMessagePopupVisibility.next(true);
    }

    /**
     * To get the global message popup visibility observable
     */
    getGlobalMessagePopupVisibility(): Subject<boolean> {
        return this.globalMessagePopupVisibility;
    }

    /**
     * To toggle global message popup visibility
     * @param visibility {boolean} global message popup visibility 
     */
    toggleGlobalMessagePopupVisibility(visibility: boolean): void {
        this.globalMessagePopupVisibility.next(visibility);
    }


}
